import type { Bookmark } from "api/schemas/bookmarksApiSchemas";
import { ClusterListItem } from "domains/clusters/components/ClusterListItem";
import { InteractiveDataListItem } from "domains/knowledgeData/components/InteractiveDataListItem";
import { PublicationListItem } from "domains/publication/components/PublicationListItem";
import { VideoListItem } from "domains/videos/components/VideoListItem";

type BookmarkItemProps = { bookmark: Bookmark; isSelected?: boolean };

export const BookmarkItem = ({ bookmark, isSelected = false }: BookmarkItemProps) => {
  if (bookmark.type === "cluster") {
    return (
      <ClusterListItem
        cluster={bookmark}
        isCompact
        isSelected={isSelected}
        link={`/bookmarks/${bookmark.id}`}
        shareLink={`/monitor/emerging-themes/${bookmark.id}`}
        trackPage="Bookmarks"
      />
    );
  }

  if (bookmark.embedded_media || bookmark.attachment?.type === "video") {
    return (
      <VideoListItem
        title={bookmark.title}
        description={bookmark.summary}
        imageUrl={bookmark.images?.x_small}
        source={bookmark.source}
        timestamp={bookmark.time}
        key={bookmark.id}
        link={`/bookmarks/${bookmark.id}`}
        isSelected={isSelected}
        trackPage="Bookmarks"
      />
    );
  }

  if (bookmark.interactive_link) {
    return (
      <InteractiveDataListItem
        key={bookmark.id}
        title={bookmark.title}
        imageUrl={bookmark.images?.x_small}
        link={`/bookmarks/${bookmark.id}`}
        source={bookmark.source}
        timestamp={bookmark.time}
        isSelected={isSelected}
        trackPage="Bookmarks"
      />
    );
  }

  return (
    <PublicationListItem
      title={bookmark.title}
      description={bookmark.summary}
      imageUrl={bookmark.images?.x_small}
      source={bookmark.source}
      timestamp={bookmark.time}
      key={bookmark.id}
      link={`/bookmarks/${bookmark.id}`}
      isSelected={isSelected}
      trackPage="Bookmarks"
    />
  );
};
